import SidebarShell, { SidebarItem } from '@/components/sidebar/SidebarShell'
import { useRole } from '@/hooks/useRole'
import { SharedProps } from '@/types'
import { usePage } from '@inertiajs/react'
import {
  IconBooks,
  IconBuilding,
  IconBuildingStore,
  IconCash,
  IconCreditCard,
  IconFileEuro,
  IconFileInvoice,
  IconFingerprint,
  IconPlugConnected,
  IconMessage,
  IconPrinter,
  IconReceipt,
  IconRoute,
  IconShoppingCart,
  IconUsers,
} from '@tabler/icons-react'

export default function AtelierSidebar() {
  const { url, props } = usePage<SharedProps>()
  const { isAdmin, isAccueil, isCourier } = useRole()
  const organization = props.current_organization!

  const base = `/organizations/${organization.slug}`
  const settingsUrl = `${base}/settings`

  if (isCourier) {
    const courierItems: SidebarItem[] = [
      {
        type: 'link',
        label: 'Mes Commandes',
        href: `${base}/couriers/orders`,
        icon: IconShoppingCart,
        active: url.includes('/couriers/orders'),
      },
    ]
    return <SidebarShell items={courierItems} />
  }

  const items: SidebarItem[] = [
    {
      type: 'link',
      label: organization.name,
      href: settingsUrl,
      icon: IconBuilding,
      active: url === settingsUrl,
    },
    { type: 'divider' },
    { type: 'section', label: 'Particuliers' },
    {
      type: 'link',
      label: 'Comptoir',
      href: `${base}/comptoir_atelier?mode=particulier`,
      icon: IconShoppingCart,
      active: url.includes('/comptoir_atelier') && url.includes('mode=particulier'),
    },
    {
      type: 'link',
      label: 'Clients',
      href: `${base}/customers`,
      icon: IconUsers,
      active: url.includes('/customers'),
    },
    { type: 'section', label: 'Sociétés' },
    {
      type: 'link',
      label: 'Comptoir',
      href: `${base}/comptoir_atelier?mode=societe`,
      icon: IconBuildingStore,
      active: url.includes('/comptoir_atelier') && url.includes('mode=societe'),
    },
    {
      type: 'link',
      label: 'Contrats',
      href: `${base}/contracts`,
      icon: IconFileInvoice,
      active: url.includes('/contracts'),
    },
    { type: 'section', label: 'Production' },
    {
      type: 'link',
      label: 'Commandes',
      href: `${base}/confirmed_orders`,
      icon: IconReceipt,
      active: url.includes('confirmed_orders'),
    },
    {
      type: 'link',
      label: 'Envoi SMS',
      href: `${base}/notifications`,
      icon: IconMessage,
      active: url.includes('notifications'),
    },
    { type: 'section', label: 'Finance', visible: isAdmin || isAccueil },
    {
      type: 'link',
      label: 'Z de Caisse',
      href: `${base}/payments`,
      icon: IconCash,
      active: url.includes('payments'),
      visible: isAdmin || isAccueil,
    },
    {
      type: 'link',
      label: 'Récap. Sociétés',
      href: `${base}/recaps`,
      icon: IconFileInvoice,
      active: url.includes('/recaps'),
      visible: isAdmin,
    },
    {
      type: 'link',
      label: 'Factures',
      href: `${base}/invoices`,
      icon: IconFileEuro,
      active: url.includes('/invoices') || url.includes('/invoice_batches'),
      visible: isAdmin && organization.e_invoicing_available,
    },
    { type: 'section', label: 'Configuration' },
    {
      type: 'link',
      label: 'Catalogue',
      href: `${base}/article_services`,
      icon: IconBooks,
      active: url.includes('article_services'),
    },
    {
      type: 'link',
      label: 'Imprimantes',
      href: `${base}/printers`,
      icon: IconPrinter,
      active: url.includes('/printers'),
    },
    {
      type: 'link',
      label: 'Zones',
      href: `${base}/zones`,
      icon: IconRoute,
      active: url.includes('/zones'),
      visible: isAdmin,
    },
    {
      type: 'link',
      label: 'Autorisations',
      href: `${base}/authorizations`,
      icon: IconFingerprint,
      active: url.includes('authorizations'),
    },
    {
      type: 'link',
      label: 'Facture électronique',
      href: `${base}/e_invoicing_setting`,
      icon: IconPlugConnected,
      active: url.includes('/e_invoicing_setting'),
      visible: isAdmin && organization.e_invoicing_available,
    },
    {
      type: 'link',
      label: 'Abonnement',
      href: `${base}/billing`,
      icon: IconCreditCard,
      active: url.includes('/billing'),
      visible: isAdmin,
    },
  ]

  return <SidebarShell items={items} />
}
